import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../services/api';
import { FaCalendarPlus, FaClock, FaCut } from 'react-icons/fa';

function MeusAgendamentos() {
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get('/appointments')
            .then(res => {
                setAppointments(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    return (
        <div>
            <div className="dashboard-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '1rem' }}>
                <div>
                    <h1>Meus Agendamentos</h1>
                    <p>Gerencie seus horários.</p>
                </div>
                <Link to="/plataforma/agendar" className="btn-primary">
                    <FaCalendarPlus style={{ marginRight: '0.5rem' }} />
                    Novo Agendamento
                </Link>
            </div>

            {loading ? (
                <p>Carregando agendamentos...</p>
            ) : appointments.length === 0 ? (
                <div className="dashboard-card">
                    <p>Você não tem agendamentos futuros.</p>
                </div>
            ) : (
                <div className="card-grid">
                    {appointments.map(app => (
                        <div key={app.id} className="dashboard-card">
                            <div className="card-title">
                                <FaCut style={{ color: 'var(--primary-color)' }} />
                                {app.service}
                            </div>
                            <div style={{ marginBottom: '1rem' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                                    <FaCalendarPlus style={{ color: '#999' }} />
                                    <span>{new Date(app.date).toLocaleDateString()}</span>
                                </div>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <FaClock style={{ color: '#999' }} />
                                    <span>{new Date(app.date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
                                </div>
                            </div>
                            <div style={{ fontSize: '0.9rem', color: app.status === 'confirmed' ? 'green' : 'orange', fontWeight: 'bold' }}>
                                Status: {app.status === 'confirmed' ? 'Confirmado' : 'Pendente'}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default MeusAgendamentos;
